let routes = [
  {
    path: 'unauthCallback',
    component: () => import('@/views/Auth/Callback'),
    name: 'callback',
    meta: {
      layout: () => import('@/layouts/Empty'),
    }
  },
];

export default routes;

